var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bullet-block"},[_c('div',{staticClass:"bullet-circle"},[_vm._v("\n    "+_vm._s(_vm.bulletText)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"section-text"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }